import React from 'react'
import { PositionProvider } from '../../components/Position/provider/PositionProvider'
import PositionWrapper from '../../components/Position/screens/PositionWrapper'

interface PositionPageProps {}

export const PositionPage: React.FC<PositionPageProps> = () => {
  return (
    <PositionProvider>
      <PositionWrapper />
    </PositionProvider>
  )
}
